var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"leaveWord"},[_c('avue-crud',{attrs:{"data":_vm.data,"option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }